import { SQUAREDEAL_DOCS_URL } from '@/utils/squareDealDocs';

/**
 * The word SquareDeal as a new-tab link to the official forms site.
 */
export function SquareDealLink({ children = 'SquareDeal', className = 'text-primary hover:underline' }) {
  return (
    <a
      href={SQUAREDEAL_DOCS_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="SquareDeal (opens in a new tab)"
      className={className}
    >
      {children}
    </a>
  );
}
